(function() {
  const IMAGES = window.SLT_MENU_IMAGES || {};
  console.log('SLT menu images:', IMAGES);

  function init() {
    const wrappers = document.querySelectorAll('.header-mega--menu');
    let panel = null;
    wrappers.forEach(w => {
      const t = w.querySelector('.summary span')?.textContent?.trim();
      if (t === 'Produkte') panel = w.querySelector('[id^="HeaderMenu-MenuList-"]');
    });
    if (!panel) return;

    panel.classList.add('slt-hover-menu');
    const aside = document.createElement('div');
    aside.className = 'slt-menu-hover-image';
    const img = document.createElement('img');
    img.alt = '';
    aside.appendChild(img);
    panel.appendChild(aside);

    const firstUrl = Object.values(IMAGES)[0];
    if (firstUrl) img.src = firstUrl;

    panel.querySelectorAll('.col-3 .wbmenuinner > a').forEach(a => {
      a.addEventListener('mouseenter', () => {
        const url = IMAGES[a.textContent.trim()];
        if (url) img.src = url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* CUSTOM CHANGE - Bauer - 2026-09-28: Notloesung. Shopify liefert auf deutschen Seiten
   routes.root "/en/" (Support-Fall offen). Schreibt /en/-Links auf deutschen Seiten auf "/" um.
   Entfernen, sobald Shopify den Fehler behoben hat. */
(function() {
  if (document.documentElement.lang !== 'de') return;
  const EN = /^((?:https?:)?\/\/slt-bauer\.de)?\/en(?=\/|$|\?|#)\/?/;
  const fix = v => v.replace(EN, (m, host) => (host || '') + '/');

  if (window.Shopify && Shopify.routes) Shopify.routes.root = '/';
  if (window.routes) Object.keys(window.routes).forEach(k => {
    if (typeof window.routes[k] === 'string') window.routes[k] = fix(window.routes[k]);
  });

  function fixAll(scope) {
    scope.querySelectorAll('a[href], form[action]').forEach(el => {
      const attr = el.tagName === 'FORM' ? 'action' : 'href';
      const v = el.getAttribute(attr);
      if (EN.test(v)) el.setAttribute(attr, fix(v));
    });
  }

  fixAll(document);
  new MutationObserver(list => list.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType === 1) fixAll(n.parentNode || n);
  }))).observe(document.documentElement, { childList: true, subtree: true });
})();
